import {
  createFileRoute,
  useNavigate,
  useParams,
  useSearch,
} from "@tanstack/react-router";
import { useEffect } from "react";

import { MainLayout } from "@/components/layouts/main-layout";
import { LoadingSpinner } from "@/components/ui/spinner";
import { useUpdateInvoice } from "@/queries/invoices/update";

type SearchParams = {
  returnTo?: string;
};

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_focused/rechnung/$id/is-booking",
)({
  validateSearch: (search: Record<string, unknown>): SearchParams => ({
    returnTo: search.returnTo as string | undefined,
  }),
  component: SetInvoiceAsBookingRouter,
});

function SetInvoiceAsBookingRouter() {
  const navigate = useNavigate();
  const { company, id } = useParams({ from: Route.id });
  const { returnTo } = useSearch({ from: Route.id });
  const [updateInvoice] = useUpdateInvoice();

  useEffect(() => {
    const setIsBooking = async () => {
      try {
        await updateInvoice({
          invoiceId: id,
          isBooking: true,
        });
      } finally {
        navigate({
          to: "/$company/buchhaltung/rechnung/$id",
          params: { company, id },
          search: returnTo ? { returnTo } : undefined,
          replace: true,
        });
      }
    };

    setIsBooking();
  }, []);

  return (
    <MainLayout>
      <div className="h-screen w-screen flex justify-center items-center">
        <LoadingSpinner />
      </div>
    </MainLayout>
  );
}
